export default [
    {
        path: '/integrations/databricks-import',
        name: 'integrations-databricks-import',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Importação de Ofertas',
            icon: 'mdi-database-import',
            breadcrumbs: [
                { text: 'Integrações', disabled: true },
                { text: 'Importação de Ofertas', disabled: true },
            ],
        },
    },
]
